import axios from "axios";
import { getConfigHeader, refrech, URL_USER } from "./config";

const findAll = async () => {
  return refrech()
    .then(() => axios.get(URL_USER, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

const findAllByClient = async (id) => {
  return refrech()
    .then(() => axios.get(URL_USER + "?client_id=" + id, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

const deleteOne = async (id) => {
  return refrech()
    .then(() => axios.delete(URL_USER + `?id=${id}`, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

const findOne = async (id) => {
  return refrech()
    .then(() => axios.get(URL_USER + `?id=${id}`, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

const findOneByLogin = async (login) => {
  return refrech()
    .then(() => axios.get(URL_USER + `?login=${login}`, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

const save = async (USER) => {
  const formData = new FormData();

  for (const key in USER) {
    if (Object.hasOwnProperty.call(USER, key)) {
      const element = USER[key];
      formData.append(key, element);
    }
  }

  if (USER.photo !== undefined) {
    formData.append("photo", USER.photo);
  } else {
    formData.delete("photo");
  }

  return refrech()
    .then(() => axios.post(URL_USER, formData, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

export { save, findAll, deleteOne, findOne, findAllByClient, findOneByLogin };
